import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, GridLegacy as Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithActionButtons } from '../../../../components/designe/app-bars/app-bar-with-buttons/AppBarWithActionButtons';
import AppUserAvatar from '../../../../components/designe/app-entity-avatar/app-user-avatar/AppUserAvatar';
import ViewField from '../../../../components/reusable/view-field/ViewField';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { AvatarSize, AvatarTypes } from '../../../../shared/constants';
import { Paths } from '../../../../shared/paths';
import { useStyles } from './UserInfoView.styles';
import { useUserInfoViewComponent } from './useUserInfoViewComponent';

export default function UserInfoView(props) {
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { user, avatar } = useUserInfoViewComponent();

  const { replace } = useNavigationStack();

  return (
    <div className={classes.userInfoWrapper}>
      <Box className={classes.userInfoContent}>
        <Box className={classes.avatarWrapper}>
          <div className={classes.avatarWrapper}>
            <AppUserAvatar
              fileBlob={avatar?.fileBlob}
              entity={user}
              size={AvatarSize.l}
              type={AvatarTypes.square}
            />
          </div>
        </Box>
        <Box>
          <ViewField
            label={t('common.firstname')}
            value={user.firstname}
            className={classes.viewItem}
          />
        </Box>
        <Box>
          <ViewField
            label={t('common.lastname')}
            value={user.lastname}
            className={classes.viewItem}
          />
        </Box>
        <Box>
          <ViewField
            label={t('common.description')}
            value={user.description}
            className={classes.viewItem}
          />
        </Box>
        <Box className={classes.buttonWrapper}>
          <AppBarWithActionButtons
            onEditClick={() => replace(Paths.settings.toInfoEdit)}
          />
        </Box>
      </Box>
    </div>
  );
}
